(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-cart-mensusa"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.formId = this.dataset.productFormId;
      this.watchTargetId = this.dataset.watchTarget;
      this.syncingFromMain = false;

      this.qtyInput = this.querySelector('.sticky-atc__qty-input');
      this.addButton = this.querySelector(`#StickyAddToCartButton-${this.sectionId}`);
      this.selects = this.querySelectorAll('.sticky-atc__select');

      this.bindQuantity();
      this.bindVariantSelects();
      this.bindAddToCart();
      this.bindVisibility();
      this.bindMainFormSync();
    }

    getMainForm() {
      return document.getElementById(this.formId);
    }

    getVariantSelects() {
      return (
        document.getElementById(`variant-selects-${this.sectionId}`) ||
        document.querySelector(`#ProductInfo-${this.sectionId} variant-selects`) ||
        document.querySelector('variant-selects')
      );
    }

    getMainQuantityInput() {
      return (
        document.querySelector(`quantity-input[data-section="${this.sectionId}"] input[name="quantity"]`) ||
        document.querySelector(`#ProductInfo-${this.sectionId} input.quantity__input[name="quantity"]`) ||
        document.querySelector(`#ProductInfo-${this.sectionId} input[name="quantity"]`)
      );
    }

    bindQuantity() {
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');

      if (minus) {
        minus.addEventListener('click', () => {
          const value = Math.max(1, parseInt(this.qtyInput.value || '1', 10) - 1);
          this.qtyInput.value = value;
          this.syncQuantityToMainForm(value);
        });
      }

      if (plus) {
        plus.addEventListener('click', () => {
          const value = parseInt(this.qtyInput.value || '1', 10) + 1;
          this.qtyInput.value = value;
          this.syncQuantityToMainForm(value);
        });
      }

      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => {
          const value = Math.max(1, parseInt(this.qtyInput.value || '1', 10));
          this.qtyInput.value = value;
          this.syncQuantityToMainForm(value);
        });
      }
    }

    syncQuantityToMainForm(value) {
      if (this.syncingFromMain) return;
      const mainQtyInput = this.getMainQuantityInput();
      if (!mainQtyInput) return;
      mainQtyInput.value = value;
      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    bindVariantSelects() {
      this.selects.forEach((select) => {
        select.addEventListener('change', () => {
          if (this.syncingFromMain) return;
          this.applyOptionToMainForm(select.dataset.optionPosition, select.value);
        });
      });
    }

    // Dawn 15 uses <variant-selects> with fieldsets (swatch/button) or <select>
    // in option order — not data-option-position attributes.
    applyOptionToMainForm(position, value) {
      const variantSelects = this.getVariantSelects();
      if (!variantSelects) return;

      const index = parseInt(position, 10) - 1;
      if (Number.isNaN(index) || index < 0) return;

      const optionContainers = variantSelects.querySelectorAll(
        'fieldset.product-form__input, .product-form__input--dropdown'
      );
      const container = optionContainers[index];
      if (!container) return;

      const radio = container.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const dropdown = container.querySelector('select');
      if (dropdown && dropdown.value !== value) {
        dropdown.value = value;
        Array.from(dropdown.options).forEach((option) => {
          if (option.value === value) option.setAttribute('selected', 'selected');
          else option.removeAttribute('selected');
        });
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateStickyFromVariant(variant) {
      if (!variant) return;
      this.syncingFromMain = true;

      this.selects.forEach((select) => {
        const position = parseInt(select.dataset.optionPosition, 10) - 1;
        const optionValue = variant.options?.[position];
        if (optionValue != null) select.value = optionValue;
      });

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        const label = this.addButton.querySelector('.sticky-atc__button-text');
        if (label) {
          label.textContent = variant.available
            ? window.stickyAtcStrings?.addToCart || window.variantStrings?.addToCart || 'Add to cart'
            : window.stickyAtcStrings?.soldOut || window.variantStrings?.soldOut || 'Sold out';
        }
      }

      const stickyPrice = document.getElementById(`StickyPrice-${this.sectionId}`);
      const mainPrice = document.getElementById(`price-${this.sectionId}`);
      if (stickyPrice && mainPrice) {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      }

      this.syncingFromMain = false;
    }

    bindMainFormSync() {
      // Main → sticky: Dawn publishes pubsub "variant-change", not DOM "variant:change"
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = event?.data?.sectionId;
          if (sectionId && String(sectionId) !== String(this.sectionId)) return;
          this.updateStickyFromVariant(event?.data?.variant);
        });
      }

      // Fallback: watch main variant picker changes directly
      const variantSelects = this.getVariantSelects();
      if (variantSelects) {
        variantSelects.addEventListener('change', () => {
          // After Dawn settles, mirror currently selected option values into sticky selects
          requestAnimationFrame(() => {
            this.syncingFromMain = true;
            const containers = variantSelects.querySelectorAll(
              'fieldset.product-form__input, .product-form__input--dropdown'
            );
            this.selects.forEach((select) => {
              const index = parseInt(select.dataset.optionPosition, 10) - 1;
              const container = containers[index];
              if (!container) return;
              const checked = container.querySelector('input[type="radio"]:checked');
              const dropdown = container.querySelector('select');
              if (checked) select.value = checked.value;
              else if (dropdown) select.value = dropdown.value;
            });
            this.syncingFromMain = false;
          });
        });
      }

      // Quantity: main → sticky
      const mainQtyInput = this.getMainQuantityInput();
      if (mainQtyInput && this.qtyInput) {
        this.qtyInput.value = mainQtyInput.value || this.qtyInput.value;
        mainQtyInput.addEventListener('change', () => {
          this.syncingFromMain = true;
          this.qtyInput.value = mainQtyInput.value;
          this.syncingFromMain = false;
        });
      }
    }

    bindAddToCart() {
      if (!this.addButton) return;
      this.addButton.addEventListener('click', () => {
        // Ensure sticky selections are pushed to the main form before submit
        this.selects.forEach((select) => {
          this.applyOptionToMainForm(select.dataset.optionPosition, select.value);
        });
        if (this.qtyInput) this.syncQuantityToMainForm(this.qtyInput.value);

        const mainForm = this.getMainForm();
        if (!mainForm) return;
        const mainSubmitButton = mainForm.querySelector('[name="add"], button[type="submit"]');
        if (mainSubmitButton) mainSubmitButton.click();
      });
    }

    bindVisibility() {
      const target = document.getElementById(this.watchTargetId);
      if (!target || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      observer.observe(target);
    }

    disconnectedCallback() {
      if (typeof this.unsubscribeVariant === 'function') this.unsubscribeVariant();
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

  const stickyCart = document.querySelector('.sticky-atc');

  if (stickyCart) {
    const stickyTop = stickyCart.offsetTop;

    function toggleElementsVisibility(hide) {
      const chatApp = document.querySelector('.gallery-navigation--scroll-button.scroll-right');
      // const saWidget = document.querySelector('.sa-widget__cta.bottom-right.icon-medium');
      const kpTrigger = document.querySelector('#kp-trigger');
      const ShippingLay = document.querySelector('.float-shipping-button');
      const playIcon = document.querySelector('.icon-play-thumb');
      const ProductExpand = document.querySelector('.product-gallery--expand');

      if (chatApp) chatApp.style.display = hide ? 'none' : '';
      // if (saWidget) saWidget.style.display = hide ? 'none' : '';
      if (kpTrigger) {
        kpTrigger.style.setProperty('display', hide ? 'none' : '', 'important');
      }
      if (ShippingLay) ShippingLay.style.display = hide ? 'none' : '';
      if (playIcon) playIcon.style.display = hide ? 'none' : '';
      if (ProductExpand) ProductExpand.style.display = hide ? 'none' : '';
    }

    function toggleSticky() {
      if (window.scrollY < stickyTop) {
        stickyCart.classList.add('is-fixed');
        toggleElementsVisibility(true);
      } else {
        stickyCart.classList.remove('is-fixed');
        toggleElementsVisibility(false);
      }
    }

    window.addEventListener('scroll', toggleSticky);
    window.addEventListener('load', toggleSticky);
  }
  } catch(e) { console.error(e); }
})();

})();
